<template>
  <div v-if="isTypingEnabled" ref="container" class="typewriter-container input-content" :class="{ 'typing-enabled': isTypingEnabled }">
    <span v-for="(char, index) in displayedContent" :key="index">{{ char }}</span>
    <span v-if="isTypingEnabled && cursorBlink && displayedContent.length < content.length" class="cursor">|</span>
  </div>
  <div v-else class="typewriter-container info-input">
    <el-input v-model="displayedContent" type="textarea" :autosize="{ minRows: 6, maxRows: 10}" @input="handleContentChange"></el-input>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      required: true
    },
    isTypingEnabled: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      displayedContent: '',
      cursorBlink: true,
      typingInterval: null
    }
  },
  mounted () {
    if (!this.isTypingEnabled) {
      this.displayedContent = this.content
    }
    setInterval(this.toggleCursorBlink, 200) // 光标闪烁的频率（毫秒）
  },
  methods: {
    startTyping () {
      this.displayedContent = ''
      this.typingInterval = setInterval(() => {
        if (this.displayedContent.length < this.content.length) {
          this.displayedContent += this.content[this.displayedContent.length]
          this.cursorBlink = !this.cursorBlink
          this.scrollToBottom()
        } else {
          clearInterval(this.typingInterval)
          this.cursorBlink = false
          this.$emit('closeTyping', false)
        }
      }, 25) // 每个字符之间的延迟时间（毫秒）
    },
    toggleCursorBlink () {
      this.cursorBlink = !this.cursorBlink
    },
    scrollToBottom () {
      this.$nextTick(() => {
        if (this.$refs.container.scrollHeight > this.$refs.container.clientHeight) {
          this.$refs.container.scrollTop = this.$refs.container.scrollHeight
        }
      })
    },
    handleContentChange () {
      if (!this.contentChangeDebounce) {
        this.contentChangeDebounce = _.debounce(() => {
          this.$emit('change', this.displayedContent)
        }, 500)
      }
      this.contentChangeDebounce()
    }
  },
  watch: {
    show: {
      handler () {
        if (this.show && !this.isTypingEnabled) {
          this.displayedContent = this.content
        }
      },
      immediate: true
    },
    isTypingEnabled: {
      handler () {
        if (this.isTypingEnabled) {
          this.startTyping()
        } else {
          clearInterval(this.typingInterval)
          this.displayedContent = this.content
          this.cursorBlink = false
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.typewriter-container {
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  border: 1px solid #ccc;
  padding: 8px;
}

.input-content {
  min-height: 160px;
  max-height: 220px;
}

.info-input {
  border: 0;
  padding: 0;
  ::v-deep {
    .el-textarea__inner {
      padding: 14px;
    }
  }
}

.cursor {
  display: inline-block;
  width: 1px;
  height: 1em;
  animation: blink 0.5s step-end infinite;
}

@keyframes blink {
  to {
    visibility: hidden;
  }
}

.typing-enabled .cursor {
  visibility: visible;
}
</style>
